export const dispatchDeleteUrl = (action, dispatch) => url =>
  dispatch(action, {
    method: 'DELETE',
    url,
  })
